import baseRequest from "../_core/baseRequest";

export default {
    /* havuz bölgesinin günlük vardiya forecastlerini getirir */
    getDailyForecast: params => baseRequest.post(`poolshifts/getDailyForecast`, params),

    /* havuz bölgesine belirtilen tarih için forecast oluşturur */
    setDailyForecast: params => baseRequest.post(`poolshifts/setDailyForecast`, params),

    /* havuz bölgesine belirtilen tarih için forecast bilgilerini getirir */
    getPoolShiftForecastByDate: params =>
        baseRequest.get(
            `poolshifts/poolShiftForecastByDate?date=${params.date}&poolId=${params.poolId}`
        ),

    /* havuz bölgesinden seçilen forecasti siler */
    removeDailyForecast: props => baseRequest.post(`poolshifts/removeDailyForecast`, props),

    /* havuz bölgesinde seçilen forecast için hesaplama yaptırır */
    calculatePoolShiftSlotForecast: params =>
        baseRequest.post(`poolshifts/calculatePoolShiftSlotForecast`, params),

    /* havuz bölgesinde seçilen forecastin gösterimini sağlar */
    showDailyForecast: params => baseRequest.post(`poolshifts/showDailyForecast`, params),

    /*seçilen havuz bölgelerine ait forecast bilgilerini kopyalar*/
    copyForecast: params => baseRequest.post(`poolshifts/copyForecastToSpecificDate`, params),

    /* havuz bölgesi vardiya sistemi için genel saat slotlarını listeler (yarım saatlik slotlar...) */
    getShiftHours: () => baseRequest.get(`poolshifts/getShiftHours`),

    /* havuz bölgesinin slot tablosuna ait hücreleri listeler */
    getDailyShiftTable: () => baseRequest.get(`poolshifts/getDailyShiftTable`),

    /* havuz bölgesine ait seçilen tarih aralığındaki hücrelerdeki verileri listeler */
    getDailySlotsByPoolId: props => baseRequest.post(`poolshifts/getDailySlotsByPoolId`, props),

    /* havuz bölgesine ait tüm vardiya bilgilerini listeler */
    getAllPoolShifts: props =>
        baseRequest.get(
            `poolshifts/getAll?${props?.page ? `page=${props.page}` : ""}${
                props?.limit ? `&limit=${props.limit}` : ""
            }`
        ),

    /* havuz bölgesine seçilen vardiya slotunu günceller */
    setDailySlotById: props => baseRequest.post(`poolshifts/setDailySlotById`, props),

    /* havuz bölgesine ait vardiya bilgilerini listeler */
    getCourierShiftTable: props => baseRequest.post(`poolshifts/getCourierShiftTable`, props),

    /* havuz bölgesine ait kuryeleri listeler */
    getPoolCouriers: props => baseRequest.post(`poolshifts/getPoolCouriers`, props),

    /* havuz bölgesine ait vardiya iptal taleplerini listeler */
    getCancelRequests: props => baseRequest.post(`poolshifts/getCancelRequests`, props),

    /* havuz bölgesine ait vardiya iptal talebini onaylar */
    approveCancelRequest: props => baseRequest.post(`poolshifts/approveCancelRequest`, props),

    /* havuz bölgesine ait vardiya slotuna kurye ataması yapar */
    bookSlotByDateAndHour: props => baseRequest.post(`poolshifts/bookSlotByDateAndHour`, props),

    /* havuz bölgesine ait vardiya slotundaki kurye atamasını iptal eder */
    cancelSlotByDateAndHour: props => baseRequest.post(`poolshifts/cancelSlotByDateAndHour`, props),

    /* havuz bolgesine ait vardiya raporunu listeler */
    poolShiftsReport: props => baseRequest.post(`poolshifts/listPoolShiftReports`, props),

    /* havuz bölgesine ait kurye vardiyalarını listeler */
    getCourierPoolShifts: props => {
        const queryParams = new URLSearchParams();
        if (props?.city && props?.city !== "all") queryParams.append("city", props.city);
        if (props?.poolId && props?.poolId !== "all") queryParams.append("poolId", props.poolId);
        if (props?.date) queryParams.append("date", props.date);
        if (props?.searchText) queryParams.append("searchText", props.searchText);

        const queryString = queryParams.toString();
        return baseRequest.get(`poolshifts/poolShift${queryString ? `?${queryString}` : ""}`);
    },

    /* havuz bölgesine ait vardiya saatini değiştirir */
    changeCourierPoolShiftHour: params =>
        baseRequest.put(`poolshifts/changeCourierPoolShiftHour`, params),

    /* havuz bölgesine ait vardiya kuryesini değiştirir */
    changeCourierPoolShift: params => baseRequest.put(`poolshifts/changeCourierPoolShift`, params),

    /* havuz bölgesine ait kuryenin vardiyalarını iptal eder*/
    cancelCourierPoolShift: params => baseRequest.put(`poolshifts/cancelCourierPoolShift`, params),

    /* vardiya değişim geçmişini listeler */
    getPoolShiftSyChangeLogs: params =>
        baseRequest.post(`poolshifts/poolShiftSyChangeLogs`, params),

    /* havuz bölgelerine ait yoğunluk bilgilerini listeler*/
    getPoolsAvailableRates: props => baseRequest.post(`poolshifts/getPoolsAvailableRates`, props),

    /* seçilen kuryeye seçilen tarih aralığında joker tanımlaması yapar*/
    setJokerCourierForShift: props => baseRequest.post(`poolshifts/setJokerCourierForShift`, props),

    /* seçilen kuryenin, seçilen havuz bölgesindeki gelecek vardiyalarını kontrol eder */
    checkCouriersPoolShifts: props => baseRequest.post(`poolshifts/checkCouriersPoolShifts`, props),

    /* havuz bölgesine ait vardiya bilgilerini excel dosyasından yükler */
    bookSlotsWithExcel: params => baseRequest.post(`poolshifts/bookSlotsWithExcel`, params),

    /* seçilen havuzda, seçilen bilgi kategorisindeki kuryeleri listeler */
    getPoolCouriersByState: props =>
        baseRequest.post(`poolshifts/getCourierCountsForPoolByState`, props),

    /* seçilen kuryeye seçilen tarih aralığında havuz vardiya tanımlaması yapar*/
    bookMultipleSlots: props => baseRequest.post(`poolshifts/bookMultipleSlots`, props),

    /* seçilen gün ve saate, belirtilen limitte havuz slotu oluşturur */
    createPoolShiftDailySlot: props =>
        baseRequest.post(`poolshifts/createPoolShiftDailySlot`, props)
};
